import * as React from 'react';
import { LoadingIndicatorProps } from '../types';

export const DefaultLoadingIndicator: React.FC<LoadingIndicatorProps> = () => <div>Loading</div>;
DefaultLoadingIndicator.displayName = 'DefaultLoadingIndicator';
